define(["exports", "styled-components"], function (_exports, _styledComponents) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _styledComponents = _interopRequireDefault(_styledComponents);

  var Label = _styledComponents.default.li.withConfig({
    displayName: "Label",
    componentId: "sc-ndm377-0"
  })(["align-items:center;background-color:", ";border-radius:2px;border:solid 1px ", ";color:", ";display:flex;flex-direction:row;font-size:1.4em;font-weight:", ";height:32px;margin-bottom:8px;margin-right:8px;overflow:hidden;padding-left:8px;padding-right:8px;@media print{background-color:", ";color:", ";-webkit-print-color-adjust:exact;}"], function (_ref) {
    var theme = _ref.theme;
    return theme.colors.lightGray;
  }, function (_ref2) {
    var theme = _ref2.theme;
    return theme.colors.white;
  }, function (_ref3) {
    var theme = _ref3.theme;
    return theme.colors.dark;
  }, function (_ref4) {
    var theme = _ref4.theme;
    return theme.font.regular;
  }, function (_ref5) {
    var theme = _ref5.theme;
    return theme.colors.darkGray;
  }, function (_ref6) {
    var theme = _ref6.theme;
    return theme.colors.white;
  });

  var _default = Label;
  _exports.default = _default;
});